import { render, staticRenderFns } from "./ProjectsEdit.vue?vue&type=template&id=29657c34"
import script from "./ProjectsEdit.vue?vue&type=script&lang=js"
export * from "./ProjectsEdit.vue?vue&type=script&lang=js"
import style0 from "./ProjectsEdit.vue?vue&type=style&index=0&id=29657c34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports